import { render, staticRenderFns } from "./address-status.vue?vue&type=template&id=31d41671"
import script from "./address-status.vue?vue&type=script&lang=js"
export * from "./address-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports